import { tassign } from 'tassign';

import { CoreActions } from '../actions/core.actions';
import { NotificationActions } from '../actions/notification.actions';
import { Language, Region, RidangoReduxAction } from './../ridango.models';

export interface CoreState {
    region: Region;
    selectedLanguage: Language;
    notifications: any;
    notificationUids: string[];
    error: any;
    information: any;
    success: any;
}

export const CORE_INITIAL_STATE: CoreState = {
    region: null,
    selectedLanguage: null,
    notifications: {},
    notificationUids: [],
    error: [],
    information: [],
    success: []
};

export function coreReducer(lastState: CoreState = CORE_INITIAL_STATE, action: RidangoReduxAction): CoreState {
    switch (action.type) {
        case CoreActions.SET_REGION:
            return tassign(lastState, {
                region: action.payload,
                selectedLanguage: null
            });
        case CoreActions.SET_SELECTED_LANGUAGE:
            return tassign(lastState, {
                region: lastState.region,
                selectedLanguage: action.payload
            });
        case NotificationActions.ADD_NOTIFICATION:
            return tassign(lastState, {
                notifications: { ...lastState.notifications, [action.payload.uid]: action.payload },
                notificationUids: [...lastState.notificationUids, action.payload.uid]
            });
        case NotificationActions.ADD_GROUPED_NOTIFICATION:
            switch (action.payload.type) {
                case 'information':
                    return tassign(lastState, {
                        information: [...lastState[action.payload.type], action.payload]
                    });
                case 'error':
                    return tassign(lastState, {
                        error: [...lastState[action.payload.type], action.payload]
                    });
                case 'success':
                    return tassign(lastState, {
                        success: [...lastState[action.payload.type], action.payload]
                    });
                default:
                    return lastState;
            }

        case NotificationActions.REMOVE_ALL_NOTIFICATIONS:
            return tassign(lastState, {
                notifications: {},
                notificationUids: [],
                error: [],
                information: [],
                success: []
            });
    }

    // We don't care about any other actions right now.
    return lastState;
}
